/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { combineLatest, EMPTY, Observable } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { IProjectCatalogData, ProjectCatalogType } from '@touchplan/fancy-referencer';
import { FancyFirebaseState } from '../../common/fancy-firebase/services/fancy-firebase-state.service';
import { ILoggerService } from '@touchplan/logging';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';

@Injectable()
export class ProjectCatalogResolver {
	private logger: ILoggerService = LoggerServiceFactory.create('ProjectCatalogResolver');

	constructor(private router: Router, private fancyFirebaseState: FancyFirebaseState) {}

	public resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<IProjectCatalogData[]> {
		return combineLatest([
			this.fancyFirebaseState.getProjectCatalog$(
				route.paramMap.get('projectId'),
				ProjectCatalogType.ProjectData
			),
			this.fancyFirebaseState.getProjectCatalog$(
				route.paramMap.get('projectId'),
				ProjectCatalogType.DerivedData
			),
		]).pipe(
			take(1),
			catchError((err) => {
				this.logger.error(err);
				if (err) {
					this.redirectToProjectList();
				}
				return EMPTY;
			})
		);
	}

	private redirectToProjectList() {
		this.router.navigate(['/projects']);
	}
}
